import { combineReducers } from '@reduxjs/toolkit';

import fantomRunReducer from './fantomRun/slice';
import friendsReducer from './friends/slice';
import hackathonReducer from './hackathon/slice';
import hypnowheelReducer from './hypnowheel/slice';
import leaderboardSlice from './leaderboard/slice';
import makeTrafficSlice from './makeTraffic/slice';
import seasonInfoReducer from './season-info/slice';
import txModalReducer from './txModal/slice';
import userReducer from './user/slice';
import activityReducer from './activity/slice';
import giveAwayReducer from './giveaway/slice';

export const rootReducer = combineReducers({
  seasonInfo: seasonInfoReducer,
  fantomRun: fantomRunReducer,
  friends: friendsReducer,
  hackathon: hackathonReducer,
  hypnowheel: hypnowheelReducer,
  leaderboard: leaderboardSlice,
  makeTraffic: makeTrafficSlice,
  user: userReducer,
  txModal: txModalReducer,
  voteActivity: activityReducer,
  giveaway: giveAwayReducer,
});
